import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import {invoke} from 'lodash/fp';
import {LAZY_LOADING_DATA_SOURCE_TREE_ITEMS} from '../../../logic/data/Izenda.ReportDesignerConstants';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import LazyLoadingTreeView from 'share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView';
import DataObjectItem from './Izenda.DataObjectItem';
import DataFieldItem from './Izenda.DataFieldItem';
import Actions from './Izenda.DataSourceTreeActions';

@connect(Actions)
class DataSourceTreePrevPanel extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    expandFieldLevel: PropTypes.bool,
    useCheckBox: PropTypes.bool
  };

  static defaultProps = {
    expandFieldLevel: false,
    useCheckBox: true
  };

  constructor(props) {
    super(props);

    const { store } = props;
    this.lazyLoadingQuerySource = store.lazyLoadingQuerySource.bind(store);
    this.registerLazyLoadingStore = store.registerLazyLoadingStore.bind(store);
  }

  shouldComponentUpdate() {
    return false;
  }

  /**
   * @method renderNode
   * @description callback method that renders either the querySource or Field node
   * @param {TreeNode} node TreeNode object representing the selected data source
   * @param {Component} toogleIcon react component that renders the arrow icon
   * @param {function} toggle callback function that is invokes when the toggleIcon is clicked
   * @param {boolean} isCollapsed indicator for if the node is collapsed or not
   */
  renderNode = (node, toggleIcon, toggle, isCollapsed) => {
    const { source, nodeType } = node;

    switch (nodeType) {
      case 'QuerySource': {
        return this.renderQuerySource({ source, toggleIcon, toggle, isCollapsed, node });
      }
      case 'Field': {
        return this.renderField(source);
      }
      default: {
        return null;
      }
    }
  };

  /**
   * @method renderQuerySouce
   * @description creates a DataObjectItem for each data source that the user chooses
   * @param {ReportDesignerQuerySourceDetail} source query source that was selected from the available data sources
   * @param {TreeNode} node TreeNode object that represents the datasource selected
   */
  renderQuerySource = ({ source, node }) => {
    var { store, toggleSourceSelection } = this.props;
    var filterText = store.dataTree.filterText;

    return (
      <DataObjectItem
        node={node}
        store={store}
        dataSource={source}
        filterText={filterText}
        useCheckBox={false}
        useDeleteButton={true}
        handleCheck={toggleSourceSelection}
      />
    );
  };

  renderField = node => {
    const { store } = this.props;

    return <DataFieldItem store={store} itemData={node} filterText={store.dataTree.filterText} />;
  };

  getKey = node => {
    return node.source.id + '_' + node.source.name;
  };

  render() {
    const props = this.props;
    const {
      store: {
        dataTree,
        lazyLoadingStore = {}
      }
    } = props;
    const getChildNodes = invoke('getChildNodes');

    const classesSelected = classnames('reports-dtsourcetree', 'izenda-MiddlePanel-content');

    return (
      <div >
        <p className='izenda-SelectedPanel-header'>Selected Data Sources</p>
        <div className='izenda-SelectedPanel-content'>
          <ScrollBox autoHeight >
            <div className={classesSelected}>
              <LazyLoadingTreeView
                nodes={dataTree.selectedItemNodes}
                getKey={this.getKey}
                autoHeight={true}
                className='u_paddingRight'
                renderNode={this.renderNode}
                getChildNodes={getChildNodes}
                viewHeight={lazyLoadingStore.viewHeight}
                itemHeight={lazyLoadingStore.itemHeight}
                isLastPage={dataTree.isLastPage}
                getData={this.lazyLoadingQuerySource}
                defaultItemsNumber={LAZY_LOADING_DATA_SOURCE_TREE_ITEMS}
                registerLazyLoadingStore={this.registerLazyLoadingStore}
              />
            </div>
          </ScrollBox>
        </div>
      </div>
    );
  }
}

export default DataSourceTreePrevPanel;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataSourceTreePrevPanel.js